import React from 'react';
import PropTypes from 'prop-types';
import {Box, IconButton} from '@material-ui/core';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';

const NumberPicker = ({value, min, max, onChange, disabled, readOnly}) => {

    return (
        <Box display={'flex'} alignItems={'center'}>
            <IconButton
                disabled={value <= min || disabled}
                onClick={!readOnly ? e => onChange(value > min ? value - 1 : value, e) : () => null}
                aria-label={'more'}
                variant={'contained'}
                color={'secondary'}>
                <IndeterminateCheckBoxIcon fontSize={'large'}/>
            </IconButton>
            <Box fontSize={'h6.fontSize'} color={disabled ? 'text.disabled' : 'primary.main'} fontFamily={'NeoSansMedium'}>
                {value}
            </Box>
            <IconButton
                disabled={value >= max || disabled}
                onClick={!readOnly ? e => onChange(value < max ? value + 1 : value, e) : () => null}
                aria-label={'less'}
                variant={'contained'}
                color={'secondary'}>
                <AddBoxIcon fontSize={'large'}/>
            </IconButton>
        </Box>
    );
};

NumberPicker.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
    min: PropTypes.number,
    max: PropTypes.number,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
};

NumberPicker.defaultProps = {
    value: 0,
    onChange: (value, event) => null,
    min: Number.MIN_SAFE_INTEGER,
    max: Number.MAX_SAFE_INTEGER,
    disabled: false,
    readOnly: false,
};

export default NumberPicker;